import BaseApi from './BaseApi'

export default class Suborders extends BaseApi {
  repeatSuborder(id, params) {
    return this.http.post(`/suborders/repeat/${id}`, params)
  }
}
